const DesignCustom = () => {
  return (
    <div className='flex justify-center mx-[15px] md:mx-[0px]'>
      <div className='flex flex-col md:flex-row max-w-[1368px] gap-6'>
        <div className='border border-[#A08260] w-full md:w-[50%]'>
          <img
            src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Banners/ownringbanner.png'
            alt=''
            className='w-full h-auto'
          />
        </div>
        <div className='design-custom-design border w-full md:w-[50%] bg-white p-[12px] sm:p-[24px]'>
          <div className='flex flex-wrap'>
            <div className='flex flex-col sm:flex-row justify-center w-full gap-4 sm:gap-0'>
              <div className='h-[150px] sm:h-[200px] w-full sm:w-[50%] flex justify-center'>
                <img
                  style={{ height: '100%' }}
                  src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Custom_design/Assets/custom_img1.png'
                  alt=''
                  className='object-contain'
                />
              </div>
              <div className='flex justify-center items-center w-full sm:w-[50%] mt-4 sm:mt-0'>
                <h1 className='font-barlow font-[800] text-[32px] sm:text-[40px] md:text-[48px] leading-[40px] sm:leading-[52px] md:leading-[64px] text-[#A08260] text-center sm:text-left'>
                  Design Your Own Ring
                </h1>
              </div>
            </div>
            <div className='flex flex-col sm:flex-row justify-between w-full mt-6 sm:mt-0 gap-4 sm:gap-0'>
              <div className='border rounded-[16px] sm:rounded-tl-[16px] sm:rounded-bl-[16px] sm:rounded-tr-none sm:rounded-br-none border-[#A08260] border-[2px] flex p-[12px] sm:p-[16px] items-center gap-3'>
                {/* Number */}
                <div className='text-black font-barlow font-[600] text-[24px] sm:text-[28px]'>
                  1
                </div>

                {/* Text stacked */}
                <div className='flex flex-col leading-tight pl-3 pr-4'>
                  <span className='font-barlow font-[500] text-[16px] sm:text-[18px] text-black'>
                    Choose a
                  </span>
                  <span className='font-barlow font-[700] text-[16px] sm:text-[18px] text-[#A08260]'>
                    SETTING
                  </span>
                </div>

                {/* Icon */}
                <div className='ml-auto pl-2'>
                  <img
                    src='/svg-image-21.png'
                    alt=''
                    className='w-[16px] h-[16px] sm:w-[20px] sm:h-[20px]'
                  />
                </div>
              </div>
              <div className='border rounded-[16px] sm:rounded-tl-[16px] sm:rounded-bl-[16px] sm:rounded-tr-none sm:rounded-br-none border-[#A08260] border-[2px] flex p-[12px] sm:p-[16px] items-center gap-3'>
                {/* Number */}
                <div className='text-black font-barlow font-[600] text-[24px] sm:text-[28px]'>
                  2
                </div>

                {/* Text stacked */}
                <div className='flex flex-col leading-tight pl-3 pr-4'>
                  <span className='font-barlow font-[500] text-[16px] sm:text-[18px] text-black'>
                    Choose a
                  </span>
                  <span className='font-barlow font-[700] text-[16px] sm:text-[18px] text-[#A08260]'>
                    DIAMOND
                  </span>
                </div>

                {/* Icon */}
                <div className='ml-auto pl-2'>
                  <img
                    src='/svg-image-22.png'
                    alt=''
                    className='w-[16px] h-[16px] sm:w-[20px] sm:h-[20px]'
                  />
                </div>
              </div>
              <div className='border rounded-[16px] sm:rounded-tl-[16px] sm:rounded-bl-[16px] sm:rounded-tr-none sm:rounded-br-none border-[#A08260] border-[2px] flex p-[12px] sm:p-[16px] items-center gap-3'>
                {/* Number */}
                <div className='text-black font-barlow font-[600] text-[24px] sm:text-[28px]'>
                  3
                </div>

                {/* Text stacked */}
                <div className='flex flex-col leading-tight pl-3 pr-4'>
                  <span className='font-barlow font-[500] text-[16px] sm:text-[18px] text-black'>
                    Choose a
                  </span>
                  <span className='font-barlow font-[700] text-[16px] sm:text-[18px] text-[#A08260]'>
                    RINGS
                  </span>
                </div>

                {/* Icon */}
                <div className='ml-auto pl-2'>
                  <img
                    src='/svg-image-23.png'
                    alt=''
                    className='w-[16px] h-[16px] sm:w-[20px] sm:h-[20px]'
                  />
                </div>
              </div>
            </div>
            <div className='flex flex-col sm:flex-row items-center justify-center mt-[20px] sm:mt-[30px] gap-4 sm:gap-0'>
              <div className='text-center w-full sm:w-[60%]'>
                <span className='font-barlow text-[12px] sm:text-[14px] font-[400] leading-[18px] sm:leading-[20px] text-black block'>
                  Design your engagement ring. Receive a free setting with the
                  purchase of a 3.0 ct or larger diamond
                </span>
              </div>
              <div className='sm:pl-5 w-full sm:w-auto'>
                <button
                  className='bg-[#A08260] border border-[#A08260] rounded-[8px] text-[14px] sm:text-[16px] font-barlow font-[700] w-full sm:w-auto'
                  style={{ padding: '10px 20px' }}
                >
                  START DESIGNING
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default DesignCustom
